import useOnValueChange from "../../../hooks/useOnValueChange";
import { InputProps } from "../Calculator";
import NumberInput from "../../BuildingBlocks/NumberInput/NumberInput";

const TITLE = "סכום השקעה חודשי";
const SUBTITLE = "הסכום שיופקד בכל חודש";
const NAME = "monthly-deposit";

const MonthlyDeposit = ({ contextKey }: InputProps) => {
  const onValueChange = useOnValueChange(contextKey);

  return (
    <NumberInput
      title={TITLE}
      placeholder={SUBTITLE}
      name={NAME}
      onlyPositive
      isCurrency={true}
      onChange={(value: number) => onValueChange(value)}
    />
  );
};

export default MonthlyDeposit;
